
import BaseMixin from '@/views/mixin.vue'
import compSearch from './search'
import compInventory from './stock'
import { mapState, mapGetters } from 'vuex'
import {
    HttpGetChannelList,
    HttpBatchDelete,
    HttpBatchActivation,
    HttpBatchSetSaleStatus,
    HttpGetCodeByLineId, HttpPushStock
} from '@/service/products/channel'
import { DropdownMenu, Dropdown, DropdownItem, Icon, Button } from 'view-design'

import compImport from '../compimport'
import compPricing from './comppricing'
import compErpsku from './comperpsku'
import compVcPrice from './compervcprice'
import compSyncAsin from './compsycnasin'
import compIndex from './update'
import mixin from "./mixin"

export default {
    mixins: [BaseMixin, ],
    components: {
        compSearch,
        compImport,
        compPricing,
        compIndex,
        compInventory,
        compVcPrice,
        compSyncAsin,
        compErpsku
    },
    data () {
        return {
            isSuper: this.$store.state.userinfo.isSuper,
            fudingdan: 0,
            channelInfo: false,
            erpskuCodeList: []
        };
    },
    watch: {
        data: {
            immediate: true,
            async handler (val) {
                // console.log('数据变化', val);
                if (!val || !val.length) return;
                let productIdList = new Set();
                this.data.map(item => {
                    if (item.productChannelRelateList && item.productChannelRelateList.length > 0) {
                        item.productChannelRelateList.map(cItem => {
                            productIdList.add(cItem.productId);
                        })
                    }
                    else {
                        productIdList.add(item.productId);
                    }
                });
                await HttpGetCodeByLineId({
                    productIds: Array.from(productIdList).join(',')
                }).then(res => {
                    // console.log(res);
                    this.erpskuCodeList = new Map();
                    res.data.map(item => {
                        this.erpskuCodeList.set(item.id, item.erpSkuCode);
                    });
                    // console.log('erpskuCodeList', this.erpskuCodeList)
                }, err => {
                    // console.log(err);
                    this.$VMessage.error(err.message);
                })
            }
        }
    },
    created () {
        this.channelInfo = this.handleAuth('erp.productChannel.delete');
        this.productChannelSet = this.handleAuth('erp.productChannel.set');
        this.productChannelVcprice = this.handleAuth('erp.productChannel.vcprice');

    },
    methods: {
        httpList: HttpGetChannelList,
        handleOperates (data, type, row) {
            this.operate = {};
            switch (type) {
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.operation_see', { defaultValue: '查看' }),
                        show: true,
                        width: 1200,
                        component: "compIndex",
                        activeids: data,
                        querytype: 'query'
                    }
                    break;
                case 'queryBlank':
                    const url = this.$router.resolve({
                        name: 'prochannelUpdate',
                        params: { type: 'query' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                case 'edit': {
                    const url = this.$router.resolve({
                        name: 'prochannelUpdate',
                        params: { type: 'edit' },
                        query: { id: data },
                    });
                    window.open(url.href, '_blank');
                    break;
                }
                case 'editerpsku': {
                    this.operate = {
                        show: true,
                        title: this.$t('erp.channel.edit_sku', { defaultValue: '编辑ERPSKU' }),
                        width: 650,
                        showFooter: false,
                        component: "compErpsku",
                        itemid: data
                    }
                    break
                }
                case 'editvcprice': {
                    this.operate = {
                        show: true,
                        title: this.$t('erp.channel.edit_price', { defaultValue: '编辑VC Price' }),
                        width: 650,
                        showFooter: false,
                        component: "compVcPrice",
                        itemid: data
                    }
                    break
                }
                case 'add': {
                    this.$router.push({
                        name: 'prochannelUpdate',
                        params: { type: 'add' },
                    });
                    break;
                }

                case 'pricing':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.channel.setting_price', { defaultValue: '调价' }),
                        width: 500,
                        showFooter: false,
                        component: "compPricing",
                        comtype: 4,
                        itemrow: data
                    }
                    break
                case 'disabled': {
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        this.showDel = true;
                        this.operate = {
                            title: this.$t('global.common.inactive', { defaultValue: '停用' }),
                            desc: this.$t('erp.channel.confirm_inactive', { defaultValue: `确定停用操作？` }),
                            type,
                            id: data,
                        }
                    }
                    break;
                }
                case 'pushStock': {
                    this.checkedId = !data ? this.checkedId : [data];
                    this.showDel = true;
                    this.operate = {
                        title: "推送库存",
                        desc: "确定推送库存操作？",
                        type,
                        id: data,
                    }
                    break;
                }
                case 'actived':
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        this.showDel = true;
                        this.operate = {
                            title: this.$t('erp.channel.active', { defaultValue: '激活' }),
                            desc: this.$t('erp.channel.confirm_active', { defaultValue: `确定激活操作？` }),
                            type,
                            id: data,
                        }
                    }
                    break;
                case 'topframe':
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        this.showDel = true;
                        this.operate = {
                            title: this.$t('erp.channel.up_staff', { defaultValue: '上架' }),
                            desc: this.$t('erp.channel.confirm_up_staff', { defaultValue: `确定上架操作？` }),
                            type,
                        }
                    }
                    break;
                case 'lowframe':
                    this.checkedId = !data ? this.checkedId : [data];
                    if (this.checkedId.length == 0) {
                        this.$Message.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
                        return;
                    } else {
                        this.showDel = true;
                        this.operate = {
                            title: this.$t('erp.channel.down_staff', { defaultValue: '下架' }),
                            desc: this.$t('erp.channe.confirm_down_staff', { defaultValue: `确定下架操作？` }),
                            type,
                        }
                    }
                    break;
                case 'delete':
                    this.showDel = true;
                    this.operate = {
                        title: this.$t('global.common.delete', { defaultValue: '删除' }),
                        desc: this.$t('erp.channel.confirm_delete', { defaultValue: `删除后不可恢复，确定删除？` }),
                        type,
                        id: data,
                    }
                    break;
                case 'inventory':
                    this.operate = {
                        title: this.$t("global.common.operation_see", { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compInventory",
                        comperpsku: data,
                        querytype: 'query'
                    }
                    // window.open(process.env.VUE_APP_FBB+'/home/inventory/list?erpsku='+data, '_blank');
                    break
                case 'import':
                    this.operate = {
                        show: true,
                        title: this.$t('erp.channel.import_channel_product', { defaultValue: '导入渠道产品' }),
                        width: 460,
                        showFooter: false,
                        erpskutitle: this.$t('erp.channel.attention_1', { defaultValue: "注意！直接更新时，渠道和Seller SKU请填写正确，这是判断更新哪条数据的标准；其中ERP SKU、组合产品数量不支持批量更新，如需更新请单条手动修改；其余信息支持批量更新。" }),
                        component: "compImport",
                        comptitle: this.$t('erp.channel.has_exsit', { defaultValue: '已存在渠道产品' }),
                        actionurl: "/api/v1/ProductChannel/import",
                        downrul: '/api/v1/ProductChannel/downModel',
                    }
                    break
                case 'syncAsin': {
                    this.operate = {
                        show: true,
                        title: '同步ASIN',
                        width: 650,
                        showFooter: false,
                        component: "compSyncAsin",
                    }
                    break
                }
            }
        },
        async batchOpearte () {
            let request, { type, id } = this.operate, params = {}, callback = (res) => { this.$Message.success(res.message); };
            switch (type) {
                case 'disabled': request = HttpBatchActivation; params = { ids: this.checkedId.join(',') || id, action: "N" }; break;
                case 'actived': request = HttpBatchActivation; params = { ids: this.checkedId.join(',') || id, action: "Y" }; break;
                case 'topframe': request = HttpBatchSetSaleStatus; params = { ids: this.checkedId.join(','), action: "Hit Shelve" }; break;
                case 'lowframe': request = HttpBatchSetSaleStatus; params = { ids: this.checkedId.join(','), action: "Not Sell" }; break;
                case 'delete': request = HttpBatchDelete; params = { ids: this.checkedId.join(',') || id }; break;
                case 'pushStock': request = HttpPushStock; params = { id: this.checkedId.join(',') || id }; break;

            }
            if (!request) return;
            request(params).then(res => {
                this.$Message.success(res.message);
                this.updateList();
                // console.log(this.checkedId)
            }, err => {
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            }).finally(result => {
                this.showDel = false;
                this.operate = {};
            });
        },
        // 操作下的列表展示内容
        getOperateNodeMap (row) {
            const { id, status, accountFlag } = row
            return [{
                label: this.$t('global.common.operation_see', { defaultValue: '查看' }),
                show: true,
                params: id,
                operate: 'query'
            }, {
                label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                show: status === 'Y' && this.productChannelSet,
                // to: {
                //     name: 'prochannelUpdate',
                //     params: { type: 'edit' },
                //     query: { id },
                // },
                params: id,
                operate: 'edit'
            }, {
                label: this.$t('erp.channel.edit_sku', { defaultValue: '编辑ERPSKU' }),
                show: status === 'Y' && this.productChannelSet,
                params: id,
                operate: 'editerpsku'
            }, {
                label: this.$t('erp.channel.edit_price', { defaultValue: '编辑VC Price' }),
                show: status === 'Y' && this.productChannelVcprice && this.getAccountTypeBool(accountFlag,'amazonvendords'),
                params: id,
                operate: 'editvcprice'
            },{
                label: "推送库存",
                show: status === 'Y' && this.getAccountTypeBool(accountFlag,'amazonvendords'),
                params: id,
                operate: 'pushStock'
            },{
                label: this.$t('erp.channel.setting_price', { defaultValue: '调价' }),
                show: status === 'Y' && this.getShowPrice(accountFlag),
                params: row,
                operate: 'pricing'
            }, , {
                label: this.$tc('global.common.inactive', 2, { defaultValue: '停用' }),
                show: status === 'Y' && this.productChannelSet,
                params: id,
                operate: 'disabled'
            }, {
                label: this.$t('erp.channel.active', { defaultValue: '激活' }),
                show: status === 'N' && this.productChannelSet,
                params: id,
                operate: 'actived'
            }, {
                label: this.$t('global.common.delete', { defaultValue: '删除' }),
                show: this.channelInfo == true,
                params: id,
                operate: 'delete'
            }]
        },
        getShowPrice(val){
            let flag = false
            this.getNewAccountList.filter(item=>{
                if(item.value == val){
                    if(item.attach.type == 'amazon'){
                        flag = true
                    }
                }
            })
            return flag
        },

        getAccountTypeBool(val,type){
            let flag = false
            this.getNewAccountList.filter(item=>{
                if(item.value == val){
                    if(item.attach.type == type){
                        flag = true
                    }
                }
            })
            return flag
        }
    },
    computed: {
        ...mapState('boss', ['warehouseList']),
        ...mapGetters('diction', ['getNewDifferentAllProductList','getNewAccountList']),
        columns () {
            let datalist = [{
                type: 'selection',
                width: 60,
            }, {
                title: this.$t('global.common.operate', { defaultValue: "操作" }),
                width: 95,
                render: this.getOperateNodes,
                // render: (h, { row }) => {
                //     const id = row.id, status = row.orderStatus;
                //     // console.log(this.channelInfo)
                //     return <Dropdown placement="bottom-start" trigger="click">
                //         <Button size='small' type='info'>操作 <Icon type="md-arrow-dropdown" /></Button>
                //         <DropdownMenu slot="list" class="text-left">
                //             <DropdownItem class='splitline' nativeOnClick={this.handleOperate.bind(this, id, 'query')}>查看</DropdownItem>

                //             <DropdownItem class='splitline' v-show={row.status == 'Y'} nativeOnClick={this.handleOperate.bind(this, id, 'edit')}>编辑</DropdownItem>

                //             <DropdownItem class='splitline' v-show={row.status == 'Y'} nativeOnClick={this.handleOperate.bind(this, id, 'editerpsku')}>编辑ERPSKU</DropdownItem>

                //             <DropdownItem class='splitline' v-show={row.status == 'Y'}  nativeOnClick={this.handleOperate.bind(this, id, 'pricing', row)}>调价</DropdownItem>

                //             <DropdownItem class='splitline' v-show={row.status == 'Y'} nativeOnClick={this.handleOperate.bind(this, id, 'disabled')}>停用</DropdownItem>
                //             <DropdownItem class='splitline' v-show={row.status == 'N'} nativeOnClick={this.handleOperate.bind(this, id, 'actived')}>激活</DropdownItem>

                //             <DropdownItem class='splitline' v-show={this.channelInfo == true} nativeOnClick={this.handleOperate.bind(this, id, 'delete')}>删除</DropdownItem>

                //         </DropdownMenu>
                //     </Dropdown >
                // }
            },
            {
                title: this.$t('global.common.channel', { defaultValue: '渠道' }) + '/'+this.$t('erp.product.product_line', {defaultValue: '项目'})+'/Seller SKU',
                // width:80,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.accountFlag}</div>
                        <div><span class="font-bold">{this.findRenderLabel(this.getNewDifferentAllProductList, row.lineId)}</span></div>
                        <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.sellerSku}</a>
                            <a onClick={this.handleOperates.bind(this, row.id, 'queryBlank')}><Icon
                                class="margin-left-10 font-14" type="ios-browsers-outline"/></a>
                        </div>

                    </div>
                },

            },
                /*{
                    title: this.$t('erp.product.product_line', {defaultValue: '项目'}),
                    // width:100,
                render: (h, { row }) => {
                    return <div>
                        <div><span class="font-bold">{this.findRenderLabel(this.getNewDifferentAllProductList, row.lineId)}</span></div>
                    </div>

                },
            },*/
                {
                    title: 'title',
                    render: (h, { row }) => {

                        return (
                            <div>
                                <div>{row.title}</div>

                            </div>
                        )
                    }
                },
            {
                title: 'ERPSKU',
                render: (h, { row }) => {

                    return (
                        <div>
                            <div>{row.erpSku}</div>

                        </div>
                    )
                }
            },

            /*{
                title: this.$t('erp.product.customise_product_code', { defaultValue: '自定义产品编码' }),
                render: (h, { row }) => {
                    let erpSkuCode = [];
                    // 以防接口未完成就开始渲染数据
                    if (!this.erpskuCodeList.get) return;
                    if (row.productChannelRelateList && row.productChannelRelateList.length > 0) {
                        row.productChannelRelateList.map(item => {
                            erpSkuCode.push(this.erpskuCodeList.get(item.productId));
                        });
                        erpSkuCode = erpSkuCode.join(',');
                        // 如果都没有自定义编码展示--
                        if (!erpSkuCode.replace(/,/g, '')) {
                            erpSkuCode = '--'
                        }
                    }
                    else {
                        erpSkuCode = this.erpskuCodeList.get(row.productId);
                    }
                    return <div>{erpSkuCode ? erpSkuCode : '--'}</div>
                }
            },*/
            {
                title: this.$t('global.common.isinactive', { defaultValue: '是否停用' }),
                width: 100,
                render: (h, { row }) => {
                    return <div>{row.status == 'Y' ? this.$t('erp.global.no', { defaultValue: '否' }) : this.$t('erp.global.yes', { defaultValue: '是' })}</div>
                },

            },
            {
                title: this.$t('erp.channel.up_down_status', { defaultValue: '上下架状态' }) + '/' + this.$t('erp.b2c.shipping_method', { defaultValue: '发货方式' }),
                //width:100,
                render: (h, { row }) => {
                    let saleState;
                    switch (row.saleState) {
                        case 'Hit Shelve': saleState = this.$t('erp.channel.up_staff', { defaultValue: '上架' }); break;
                        case 'Not Sell': saleState = this.$t('erp.channel.down_staff', { defaultValue: '下架' }); break;
                        case 'Off Shelve': saleState = this.$t('erp.channel.temp_down_staff', { defaultValue: '临时下架' }); break;
                    }
                    if (row.saleState==='Hit Shelve') {
                        return <div>
                            <div style="color: green;">{saleState}</div>
                            <div>{row.skuOrderType == 0 ? this.$t('erp.channel.auto', { defaultValue: '自动' }) : this.$t('erp.channel.manual', { defaultValue: '手动' })}</div>
                        </div>;
                    }else {
                        return <div>
                            <div style="color: red;">{saleState}</div>
                            <div>{row.skuOrderType == 0 ? this.$t('erp.channel.auto', { defaultValue: '自动' }) : this.$t('erp.channel.manual', { defaultValue: '手动' })}</div>
                        </div>;
                    }

                },

            },
                {
                    title: 'Asin',
                    // width:200,
                    render: (h, { row }) => {
                        return <div>
                            <div><span class="font-bold">{row.asin || '-'}</span></div>
                            {/*<div>{row.fnSku || '-'}</div>*/}
                        </div>;

                    },
                },
            {
                title: 'Listing Img',
                // width:200,
                render: (h, { row }) => {
                    let image = row.imageUrl;
                    if (image) {
                        return <div>
                            <div style="float: left; cursor: pointer; margin-right: 10px;">
                                <img style="width: 100px; height: 100px;" src={image}></img>
                            </div>
                        </div>;
                    } else {
                        return <div>
                            <div><span>-</span></div>
                        </div>;
                    }

                },
            },
            {
                title: 'Price',
                width: 180,
                renderHeader: (h) => {
                    return (
                        <Tooltip max-width={600} placement="bottom" transfer>
                            Price
                            <div slot="content">
                                <p>Listing Price: SC（划线价） VC（预期销售价格）建议零售价</p>
                                <p>Your Price: 前台销售价价格-实际（折扣前）</p>
                                <p>Sales Price: 销售价格，折扣后</p>
                                <p>Cost Price: VC 供货价</p>
                                <p>Payment Price: VC 回款价（扣除平台扣减和服务费）</p>
                            </div>
                        </Tooltip>
                    )
                },
                render: (h, { row }) => {

                    return <div>
                        <div><span class="font-bold">Listing Price:</span> {row.price} {row.currencyCode}</div>
                        <div><span class="font-bold">Your Price:</span> {row.yourPrice} {row.currencyCode}</div>
                        <div><span class="font-bold">Sales Price: </span> {row.salePrice} {row.currencyCode}</div>
                        <div><span class="font-bold">Cost Price: </span> {row.costPrice} {row.currencyCode}</div>
                        <div><span class="font-bold">Payment Price: </span> {row.paymentPrice} {row.currencyCode}</div>
                    </div>
                }
            },
                {
                    title: this.$t('erp.product.total_inventory', { defaultValue: '总库存' }),
                    width: 80,
                    render: (h, { row }) => {
                        return <div>
                            <div><a onClick={this.handleOperates.bind(this, { accountFlag: row.accountFlag, sellerSku: row.sellerSku }, 'inventory')}>{row.stockQty == 0 ? row.stockQty : row.stockQty == null ? '--' : row.stockQty}</a></div>
                        </div>
                    },

                },
            {
                title: this.$t('erp.channel.up_staff', { defaultValue: '上架' }) + '/' + this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                // width:100,
                render: (h, { row }) => {
                    return <div>
                        <div>{row.amazonTime || '-'}</div>
                        <div>{row.updatedAt || '-'}</div>
                    </div>

                },
            },

            ];
            return datalist;
        },
    },
};




